// extracted by mini-css-extract-plugin
module.exports = {"item":"ServiceItem_item__2NWyJ","link":"ServiceItem_link__15KKN"};